const APPCONFIG = {
    apibaseurl: "http://localhost:1313/",
    smtpServer: {
        url:"smtp.libero.it",
        port:465,
        username:"digiacomomarco@libero.it",
        password:"Capocchia84",
    },
    contactMail: {
        to: "info@damatrafolk.it",
        subjecprefix: "Form contatti - "
    },
    lastEventNumber: 5
};

export default APPCONFIG;


// WEBPACK FOOTER //
// ./src/utils/appconfig.js